import React, { FC } from 'react'

export const SVGArrowLeft:FC = () => {

    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.5894 4.7556C10.9149 4.43016 10.9149 3.90252 10.5894 3.57709C10.264 3.25165 9.73634 3.25165 9.41091 3.57709L3.57757 9.41042C3.25214 9.73586 3.25214 10.2635 3.57757 10.5889L9.41091 16.4223C9.73634 16.7477 10.264 16.7477 10.5894 16.4223C10.9149 16.0968 10.9149 15.5692 10.5894 15.2438L6.17868 10.833H15.8335C16.2937 10.833 16.6668 10.4599 16.6668 9.99968C16.6668 9.53944 16.2937 9.16634 15.8335 9.16634H6.17867L10.5894 4.7556Z" fill="black"/>
    </svg>;
};
